import { Button, ButtonType } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import React, { Component } from 'react';
import styles from './row.scss';

export default class Row extends Component {
  
    onClick = (e) => {

        this.props.onClick(e, this.props.user);
    }

    render() {

        const { translations } = this.props;

        return (
            <div
                data-cy='user-row' 
                className={
                    classNames(styles.ldapUsersListItemWrapper)
                }
                style={this.props.style}
            >
                <table>
                    <tbody>
                        <tr>
                            <td className={classNames(styles.usernameWrapper)}>
                                <span
                                    title={this.props.user.username}
                                    className={classNames(styles.username)}>
                                        {this.props.user.username}
                                </span>
                            </td>
                            <td className={classNames(styles.emailWrapper)}>
                                <span
                                    title={this.props.user.email}
                                    className={classNames(styles.email)}>
                                        {this.props.user.email}
                                </span>
                            </td>
                            <td>
                                <Button 
                                    dataCy='import-user-button'
                                    style={{
                                        height: 26,
                                        lineHeight: '27px',
                                        minWidth: 0,
                                        paddingLeft: '15px',
                                        paddingLeft: '15px'
                                    }}
                                    text={translations.import}
                                    onClick={this.onClick}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/users/directoryUsers/usersList/row.jsx